export const setPageName = (title: string) => {
  document.title = `${title} | North House`;
};
